const degrees = [
  {
    school: 'School of Software Technology, Zhejiang University',
    degree: 'MA Software Engineering',
    link: 'http://www.cst.zju.edu.cn/',
    year: 2021,
  },
  {
    school: 'China Jiliang University',
    degree: 'B.S. Quality Engineering',
    link: 'https://www.cjlu.edu.cn/',
    year: 2011,
  },
];

export default degrees;
